import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";
import { createDataAttributes } from "../../utilities";
import "./Anchor.scss";

const Anchor = ({
  onClick,
  as,
  className,
  variant,
  children,
  dataAttrib,
  ...rest
}) => {
  const customClasses = classnames("uikit__anchor", className, {
    [`uikit__anchor__${variant}`]: !!variant
  });
  const As = as || "a";

  return (
    <As
      className={customClasses}
      tabIndex="0"
      role="button"
      onClick={onClick}
      onKeyDown={onClick && (evt => evt.key !== "Enter" || onClick())}
      {...createDataAttributes(dataAttrib)}
      {...rest}
    >
      {children}
    </As>
  );
};

Anchor.propTypes = {
  as(props) {
    if (!props.onClick && !props.as)
      return new Error('"as" or "onClick" is required!');

    if (!!props.as && props.as?.render?.displayName !== "Link")
      return new Error(
        'When using "as", you must pass in the React Router "Link" component.'
      );
  },
  onClick(props) {
    if (!props.onClick && !props.as)
      return new Error('"as" or "onClick" is required!');

    if (!!props.onClick && typeof props.onClick != "function")
      return new Error('When using "onClick", it must be a function');
  },
  className: propTypes.string,
  children: propTypes.oneOfType([
    propTypes.element,
    propTypes.string,
    propTypes.node
  ]),
  variant: propTypes.oneOf(["blue", "black", "red"]),
  dataAttrib: propTypes.arrayOf(Object)
};

Anchor.defaultProps = {
  className: "",
  variant: "blue"
};

export default Anchor;
